import api from '../auth';
const slug = 'api/apartments/';

const ApartmentService = () => {
    const getApartments = () => {
        return api.get(slug).then((res) => res.data);
    };

    const getApartmentsLazy = (params) => {
        return api
            .get(slug, {
                params
            })
            .then((res) => res.data);
    };

    const getApartment = (id) => {
        return api.get(slug + `show/${id}/`).then((res) => res.data);
    };

    const deleteApartment = (id) => {
        return api
            .delete(slug + `apartment/${id}/`)
            .then((res) => res.data)
            .catch((err) => {
                return err;
            });
    };

    const createApartment = (data) => {
        return api.post(slug, data).then((res) => res.data);
    };

    const updateApartment = (id, data) => {
        return api.put(slug + `apartment/${id}/`, data).then((res) => res.data);
    };

    const getOptions = () => {
        return api.options(slug).then((res) => res.data.actions.POST);
    };

    // custom action
    const copyApartment = (id) => {
        return api.post(slug + `copy/${id}/`).then((res) => res.data);
    };

    return {
        getApartments,
        getApartmentsLazy,
        getApartment,
        deleteApartment,
        createApartment,
        updateApartment,
        getOptions,
        copyApartment
    };
};

export default ApartmentService;
